export enum ROUTE_NOTIFICATION {
  HOME = 'notifications',
}
